// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"318103a3","732":"f12598a0","977":"42ff5d09"}[chunkId] + ".chunk.js";
};